import React, { useEffect } from 'react'
import MyProfileSection2 from './MyProfileSection2'
import UserInfoSection from '../Components/UserInfoSection'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';


function MyProfile() {

  let navigate = useNavigate();

  const { isUserLogin, isAdminLogin, userLoading } = useSelector((state) => state.user);

  useEffect(() => {
    if (isAdminLogin == true) {
      navigate("/user/mytravellers")

    }
  }, [])

  return (
    <div className="userdb-two-secs">
      <UserInfoSection />
      <MyProfileSection2 />
    </div>
  )
}

export default MyProfile
